import { timeFormat, timeParse } from 'd3-time-format';

const formatTime = timeFormat('%b %d');
const parseDate = timeParse('%Y-%m-%d');

export default function formatDate(date: string): string {
  const formattedDate = formatTime(parseDate(date) as Date);
  return formattedDate;
}
